// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip[data-v-5e48e98a]{z-index:unset}.menu-item[data-v-5e48e98a]{display:block;font-size:1rem;font-weight:600;line-height:1rem;padding:20px;color:#0f2345;cursor:pointer;text-decoration:none}.menu-item[data-v-5e48e98a]:hover{background:hsla(0,0%,100%,.1)}", ""]);
// Exports
module.exports = exports;
